import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import { useAuthorizedAxiosClient } from "../../../common/axios"
import { APPLY_SIGNATURE_TO_ALL_API_URL } from "./emailSignatureUtils"

export default function ApplySignatureToAllTemplatesDialog({
  open,
  onClose,
  onError,
}) {
  const [isApplying, setIsApplying] = useState(false)
  const axios = useAuthorizedAxiosClient()

  function handleSoftClose(applied = false, updatedCount = 0) {
    onClose(applied, updatedCount)
  }

  function handleApplyButtonClicked() {
    setIsApplying(true)
    axios
      .post(APPLY_SIGNATURE_TO_ALL_API_URL)
      .then(({ data }) => handleSoftClose(true, data?.updated_count ?? 0))
      .catch((error) => {
        const message =
          error?.response?.data?.detail ||
          error?.response?.data?.non_field_errors?.[0] ||
          "Could not enable signature on templates. Please try again."
        onError?.(message)
      })
      .finally(() => setIsApplying(false))
  }

  return (
    <Dialog
      open={open}
      onClose={() => handleSoftClose(false)}
      maxWidth="xs"
      fullWidth
    >
      <DialogContent>
        <Typography variant="body1">
          Add this email signature to all existing email templates? Each
          template will have the &quot;Include email signature&quot; checkbox
          turned on. You can turn it off per template at any time.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="inherit"
          onClick={() => handleSoftClose(false)}
        >
          Not now
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={isApplying}
          onClick={handleApplyButtonClicked}
        >
          Add to all templates
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
